/**
 * @description px转rem
 */

function trans(px: number): string {
  return (px / 75).toFixed(2) + 'rem'
}

export default trans